import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";

interface HowWorkProps {
  cityName: string;
}

export const HowWorkSection = ({ cityName }: HowWorkProps) => {
  const transportOptions = [
    {
      id: 1,
      icon: <Check className="text-n-green" />,
      text: (
        <>
          <strong>Transporte em caminhão cegonha</strong> - Opção mais econômica
          e segura para longas distâncias.
        </>
      ),
    },
    {
      id: 2,
      icon: <Check className="text-n-green" />,
      text: (
        <>
          <strong>Guincho ou plataforma</strong> - Ideal para curtas distâncias
          e veículos esportivos.
        </>
      ),
    },
    {
      id: 3,
      icon: <Check className="text-n-green" />,
      text: (
        <>
          <strong>Transporte expresso</strong> - Para quem precisa de mais
          agilidade na entrega.
        </>
      ),
    },
    {
      id: 4,
      icon: <Check className="text-n-green" />,
      text: (
        <>
          <strong>Porta a porta</strong> - Comodidade total com coleta e entrega
          onde for necessário.
        </>
      ),
    },
    {
      id: 5,
      icon: <Check className="text-n-green" />,
      text: (
        <>
          <strong>Carreta fechada</strong> - Para clientes que precisam de um
          agendamento mais preciso.
        </>
      ),
    },
  ];
  return (
    <section id="como-funciona" className=" py-10 md:py-24">
      <div className="container">
        <div className="grid grid-cols-1 gap-y-12 md:grid-flow-row md:grid-cols-2 md:items-center md:gap-x-12 lg:gap-x-20">
          <div className="flex flex-col gap-8">
            <h2 className="rb-5 text-3xl font-bold md:text-4xl lg:text-5xl text-n-green">
              Como funciona o<br />
              transporte de veículos em <span> {cityName}?</span>
            </h2>

            <p className=" text-n-text">
              O transporte de veículos pode ser realizado de diversas formas,
              dependendo do seu perfil e necessidade. Na Nacional GO,
              trabalhamos com:
            </p>

            <Link to="/fazer-cotacao">
              <Button id="btn-fazer-cotacao">Fazer cotação</Button>
            </Link>
          </div>

          <div>
            <ul className="flex flex-col gap-4">
              {transportOptions.map((option) => (
                <li
                  key={option.id}
                  className="flex gap-3 border rounded-2xl h-[64px] items-center border-n-primary hover:bg-n-beige/20"
                >
                  <span className="flex items-center justify-center h-full min-w-10 rounded-l-2xl border-r border-n-primary bg-n-beige ">
                    {option.icon}
                  </span>

                  <p className="text-n-text text-sm md:text-md">
                    {option.text}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
